import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import getSiteReadingsValidation, {
  SiteReadingsValidationResponse,
} from "../http/getSiteReadingsValidation";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

interface UseSiteReadingsValidationParams {
  siteId: string;
  fileGuid: string;
  month: string;
  enabled?: boolean;
}

const useSiteReadingsValidation = ({
  siteId,
  fileGuid,
  month,
  enabled,
}: UseSiteReadingsValidationParams) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchReadingsValidation: UseQueryResult<
    SiteReadingsValidationResponse,
    unknown
  > = useQuery(
    ["site", siteId, "readings_validation", fileGuid, month],
    async () => {
      return getSiteReadingsValidation(
        await getAuthTokenBlocking(getToken, relogin),
        siteId,
        fileGuid,
        month
      );
    },
    {
      enabled: (enabled ?? true) && !!fileGuid && !!month,
      staleTime: 5 * 60 * 1000,
    }
  );

  return {
    fetchReadingsValidation,
  };
};

export default useSiteReadingsValidation;
